import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { InstallationMask } from '../components/InstallationMask';
import { MenuOverlay } from '../components/MenuOverlay';
import './Installation.css';

export default function NewHomepage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleEnterVault = () => {
    navigate('/#vault');
  };

  return (
    <div className="installation-page" data-testid="installation-homepage">
      <div className="installation-grain" aria-hidden="true" />

      <header className="installation-header">
        <div className="installation-brand" data-testid="nav-brand-logo">
          <img src="/zato-mask.png" alt="" className="installation-brand-icon" />
          <span>ZATO</span>
        </div>
        <button
          className="installation-menu-button"
          onClick={() => setMenuOpen(true)}
          data-testid="nav-menu-button"
        >
          MENU <span className="installation-menu-plus">[+]</span>
        </button>
      </header>

      <main className="installation-center">
        <InstallationMask />

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3, ease: 'easeOut' }}
          className="installation-wordmark-block"
        >
          <h1 className="installation-wordmark" data-testid="installation-wordmark">ZATO</h1>
          <p className="installation-tagline">ANONYMOUS BY DESIGN</p>
          <p className="installation-subtagline">PRIVACY // SOVEREIGNTY // PRIVATE MONEY</p>
        </motion.div>

        <motion.button
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.55, ease: 'easeOut' }}
          className="installation-cta"
          onClick={handleEnterVault}
          data-testid="enter-vault-cta-button"
        >
          <span className="installation-cta-fill" aria-hidden="true" />
          <span className="installation-cta-label">ENTER THE VAULT</span>
        </motion.button>
      </main>

      <footer className="installation-footer">
        <span className="installation-footer-label">GENESIS // PORTFOLIO v2.0</span>
        <Link to="/#vault" className="installation-footer-legacy" data-testid="footer-legacy-link">
          <span className="installation-footer-legacy-full">ARCHIVE / MAIN SITE [→]</span>
          <span className="installation-footer-legacy-short">ARCHIVE [→]</span>
        </Link>
        <span className="installation-footer-status">SYSTEM: SECURE // LOCATION: REDACTED</span>
      </footer>

      <MenuOverlay open={menuOpen} onClose={() => setMenuOpen(false)} />
    </div>
  );
}
